import React from "react";
import { AspectRatio, Card, Grid, Stack, Text, useViewport } from "@bookingcom/bui-react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useUserAgent from "../../../hooks/useUserAgent.js";
import useCreateUrl from "../../../hooks/useCreateUrl.js";
import Container from "../Container/index.js";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import styles from "./HomeRecentSearch.module.css";
import useHomeRecentSearch from "./useHomeRecentSearch.controller.js";
export default function HomeRecentSearch() {
    const { apiPrefix } = useGlobalContext();
    const i18n = useI18n();
    const { isMobile } = useUserAgent();
    const { createUrl } = useCreateUrl();
    const { images, searchHistoryList, generateSearchUrlFromSearchHistory } = useHomeRecentSearch();
    const { isLarge } = useViewport();
    const canRender = searchHistoryList.length !== 0 && !isMobile;
    if (!canRender)
        return null;
    return (React.createElement(Container, { pb: isMobile ? 8 : 4, pt: 8 },
        React.createElement(Stack, { gap: 4 },
            React.createElement(Stack.Item, null,
                React.createElement(Text, { tagName: "h2", variant: "headline_2" }, i18n.trans(t("flights_continue_search_title")))),
            React.createElement(Stack.Item, null,
                React.createElement(Grid, { attributes: { style: { alignItems: "stretch", flexDirection: !isLarge ? "column" : "row" } } }, searchHistoryList.map((item, idx) => (React.createElement(Grid.Column, { size: isMobile ? 12 : 4, key: item.title || "" + item.subtitle + idx, attributes: { style: { width: !isLarge ? "100%" : undefined } } },
                    React.createElement(Card, { variant: "elevated", attributes: { style: { height: "100%" } } },
                        React.createElement("a", { style: { color: "inherit", textDecoration: "none" }, href: apiPrefix + createUrl(generateSearchUrlFromSearchHistory(item.searchhistoryItem)) },
                            React.createElement(Stack, { direction: "row", gap: 3 },
                                React.createElement(Stack.Item, null,
                                    React.createElement(AspectRatio, { attributes: {
                                            style: {
                                                borderRadius: "var(--bui_border_radius_100)",
                                                backgroundColor: "var(--bui_color_foreground_inverted)",
                                                backgroundPosition: "center center",
                                                backgroundSize: "cover",
                                                backgroundImage: `url("https://q-xx.bstatic.com${images?.[item?.photoIata || ""]?.["square210"]}")`
                                            }
                                        }, ratio: "1:1", width: "64px" })),
                                React.createElement(Stack.Item, { grow: true },
                                    React.createElement(Grid, { gap: 2 },
                                        React.createElement(Grid.Column, { size: 12 },
                                            React.createElement("div", null,
                                                React.createElement(Text, { className: styles.ellipsis, variant: "strong_2" }, item.title),
                                                React.createElement(Text, { className: styles.ellipsis, variant: "body_2" }, item.subtitle))))))))))))))));
}
